module.exports = __webpack_public_path__ + "media/lootbox_win.af3e9600.mp3";